// src/components/layouts/includes/footer.js

import React from "react";
import logo from "./../../../assets/images/logo.svg";
// import LogoFacebook from "./../../../assets/images/footer/tiktok.png";
import LogoInstagram from "./../../../assets/images/footer/insta.png";
import LogoX from "./../../../assets/images/footer/x.png";
import "./../../../assets/styles/_footer.scss";

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="logo">
          <h1>
            <img src={logo} alt="logo" />
          </h1>
        </div>
        <div className="contact-list">
          <ul>
            <li>
              <a href="https://x.com/myO2_official" target="_blank" rel="noreferrer">
                <img src={LogoX} alt="X" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/my_o2_official/" target="_blank" rel="noreferrer">
                <img src={LogoInstagram} alt="Instagram" />
              </a>
            </li>
            {/* <li>
              <a href="#">
                <img src={LogoFacebook}></img>
              </a>
            </li> */}
          </ul>
        </div>
        <div className="page-footer">
          <ul>
            <li>
              <a href="https://beaute-de-mode.jp/contact/" target="_blank" rel="noreferrer">Contact</a>
            </li>
            <li>
              <a href="https://beaute-de-mode.jp/" target="_blank" rel="noreferrer">Company</a>
            </li>
            <li>
              <a href="https://shop.beaute-de-mode.jp/policies/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>
            </li>
          </ul>
          <ul>
            <li>
              <a href="https://shop.beaute-de-mode.jp/policies/legal-notice" target="_blank" rel="noreferrer">特定商取引法に基づく表記</a>
            </li>
          </ul>
        </div>
        <p>© BEAUTE･DE･MODE All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
